/* unplugin-vue-components disabled */import { render } from "./news.vue?vue&type=template&id=450eedcf&scoped=true"
import script from "./news.vue?vue&type=script&lang=js"
export * from "./news.vue?vue&type=script&lang=js"

import "./news.vue?vue&type=style&index=0&id=450eedcf&scoped=true&lang=css"

import exportComponent from "D:\\WorkPlace\\官网\\html-bcepd-project-website-digital-read\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-450eedcf"]])

export default __exports__